import { nothing, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import type { IntervalAttributes } from 'zaptic-interval'
import { dispatchCustomEvent } from './helpers/event'
import { positiveIntegerAttributeSchema } from './helpers/yup'

@customElement('zaptic-interval')
export class Interval extends LitElement implements IntervalAttributes {
    @property({
        type: Number,
        reflect: true,
        converter: {
            fromAttribute: (val: unknown) => positiveIntegerAttributeSchema.validateSync(val),
            toAttribute: (val: number) => String(val),
        },
    })
    timeout: number

    // Tracks the interval handle
    private interval: number

    // Tracks if we are connected to the DOM
    // We only start the interval if connected
    private connected = false

    public connectedCallback() {
        super.connectedCallback()
        this.connected = true
        this.reset()
    }

    public disconnectedCallback() {
        super.disconnectedCallback()
        this.connected = false
        clearInterval(this.interval)
    }

    public updated() {
        this.reset()
    }

    private reset = () => {
        clearInterval(this.interval)

        // Only start when both connected and timeout attribute given
        if (!this.connected || !this.timeout) {
            return
        }

        this.interval = window.setInterval(this.tick, this.timeout)
    }

    private tick = () => {
        dispatchCustomEvent(this, 'zaptic-interval::tick')
    }

    render() {
        return nothing
    }
}
